
























import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import EchartOption from '@/common/const/e-chart-options';
import moment from 'moment';

@Component({
  components: {}
})
export default class ChartLeft extends Vue {
  options: EchartOption = new EchartOption();

  @Prop({ default: () => [] })
  chartData: [];
  @Prop({ default: '' })
  utilizationSum: string;
  @Prop({ default: '' })
  dimensions: string;
  @Prop({ default: () => {} })
  filterParam: any;

  @Watch('chartData')
  onChartDataChange(val) {
    this.$nextTick(() => {
      this.refreshChart();
    });
  }

  refreshChart() {
    let x = [];
    // 周转率
    let y0 = [];
    // 整理数据
    if (this.chartData.length) {
      if (this.dimensions === '00') {
        x = this.chartData.map((i: any) => i.timePoint);
      } else {
        x = this.chartData.map((i: any) => i.reportDate);
      }
      y0 = this.chartData.map((i: any) => parseFloat(i.utilization).toFixed(2));
    }
    const options: EchartOption = new EchartOption();
    options.setTitle({
      show: false
    });
    options.setColor(['#7bc0f2']);
    options.setLegend({
      show: false
    });
    options.setGrid({
      top: '15%',
      left: '5%',
      right: '17%',
      bottom: '10%',
      containLabel: true
    });
    options.setXAxis(
      {
        type: 'category',
        boundaryGap: true,
        axisLabel: {
          color: '#000'
        },
        axisTick: {
          show: false
        },
        axisLine: {
          show: false
        },
        data: x
      },
      true
    );
    options.setYAxis(
      [
        {
          type: 'value',
          axisLabel: {
            show: true,
            color: '#000',
            formatter: '{value}%'
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: '#ccc',
              type: 'dashed'
            }
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          }
        }
      ],
      true
    );
    options.setSeries([
      {
        name: '利用率',
        type: 'line',
        smooth: true,
        markLine: {
          label: {
            show: true,
            formatter: params => {
              if (params) {
                return `平均利用率 ${parseInt(this.utilizationSum)}%`;
              }
            }
          },
          data: [
            {
              yAxis: parseInt(this.utilizationSum),
              name: 'target'
            }
          ],
          lineStyle: {
            color: '#d77b86'
          }
        },
        data: y0
      }
    ]);
    options.setTooltip({
      show: true,
      trigger: 'axis',
      axisPointer: {
        type: 'line'
      },
      formatter: params => {
        let html = '';
        if (params) {
          this.chartData.forEach((item: Record<string, any>) => {
            if (this.dimensions === '00') {
              if (item.timePoint === params[0].axisValue) {
                html = `<div>
                        <div>${item.reportDate}（${item.week}）${item.reportTime}~${item.reportEndTime}</div>
                        <div><span style="display: inline-block; margin-right: 5px;border-radius: 10px;width: 10px;height: 10px;background-color: #7bc0f2;"></span>利用率：${parseInt(
                          item.utilization
                        )}%</div>
                        <div>停车总时长：${item.parkingTime}</div>
                        <div>车位数：${item.totalSpaceAmount}</div>
                      </div>`;
              }
            }
            if (this.dimensions === '01') {
              if (item.reportDate === params[0].axisValue) {
                html = `<div>
                        <div>${item.reportDate}（${item.week}）</div>
                        <div><span style="display: inline-block; margin-right: 5px;border-radius: 10px;width: 10px;height: 10px;background-color: #7bc0f2;"></span>利用率：${parseInt(
                          item.utilization
                        )}%</div>
                        <div>停车总时长：${item.parkingTime}</div>
                        <div>车位数：${item.totalSpaceAmount}</div>
                      </div>`;
              }
            }
          });
        }
        return html;
      }
    });
    this.options = options;
  }

  mounted() {}
}
